// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container, Form } from 'react-bootstrap';
import moment from 'moment';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import CourseService from 'services/CourseService';
import InstructorService from 'services/InstructorService';
import LanguageService from 'services/LanguageService';
import LocationService from 'services/LocationService';
import TextHelpers from 'helpers/TextHelpers';

// Components
import Loader from 'components/common/Loader';
import Calendar from 'components/calendar/Calendar';
import DatePicker from 'components/common/DatePicker';
import EditBookingModal from 'components/bookings/EditBookingModal';
import PageHeader from 'components/common/PageHeader';
import SideBar from 'components/common/SideBar';
import FormChecks from 'components/common/FormChecks';

//-------------------------------------------------------------------------------------------------------------------

class CalendarPage extends React.Component {

    constructor(props) {
        super(props);

        this.editBookingModalRef = React.createRef();

        this.state = {
            isLoading: true,
            isLoadingFilters: true,
            calendar: null,
            requestID: 0,
            filters: {
                dateFrom: moment().startOf('isoWeek').toDate(),
                dateTo: moment().startOf('isoWeek').add(5, 'weeks').endOf('isoWeek').toDate(),
                geoIDs: {},
                courseID: null,
                instructorID: null,
                type: 'Approved',
                isApprovedCourse: true
            }
        };
    }

    async componentDidMount() {
        GlobalStateService.setValues({ area: 'calendar' });
        window.scrollTo(0, 0);
        this.loadFilters();
    }

    async loadFilters() {
        const filters = { ...this.state.filters };
        const geosReq = LocationService.listGeos();
        const languagesReq = LanguageService.list();
        const geos = await geosReq;
        const languages = await languagesReq;
        geos.forEach(g => {
            filters.geoIDs[g.id] = true;
        });
        this.setState({
            geos,
            languages
        }, () => {
            this.load();
        });
    }

    async load() {
        const { filters } = this.state;

        const calendarReq = InstructorService.getCalendar(filters);
        const coursesReq = CourseService.list(filters);

        //const instructorsReq = InstructorService.list({
        //    ...filters,
        //    languageIDs: (filters.languageID ? { [filters.languageID]: true } : null),
        //    ignoreDeactivated: true
        //});
        //const instructors = await instructorsReq;

        const courses = await coursesReq;
        const calendar = await calendarReq;
        const instructors = calendar.instructors;

        // Filter instructor list
        let instructorsFiltered;
        if (filters.instructorID) {
            if (filters.instructorID == 'priority') {
                instructorsFiltered = instructors.filter(i => i.isPriority);
            } else if (filters.instructorID == 'non-priority') {
                instructorsFiltered = instructors.filter(i => !i.isPriority);
            } else if (instructors.find(i => i.id == filters.instructorID)) {
                instructorsFiltered = instructors.filter(i => i.id == filters.instructorID);
            } else {
                this.updateFilter('instructorID', null);
                return;
            }
        } else {
            instructorsFiltered = instructors;
        }

        //// Further filter instructor list if only showing a certain status
        //if (filters.status) {
        //    instructorsFiltered = instructorsFiltered.filter(i => {
        //        calendar.weeks.forEach(w => {
        //            const instructor = w.instructors[i.id];
        //            debugger;
        //        });
        //        //const calendar.weeks[x].instructors[ID];
        //    });
        //}

        this.setState({
            instructors,
            instructorsFiltered,
            courses,
            calendar,
            requestID: this.state.requestID + 1,
            isLoading: false,
            isLoadingFilters: false
        });
    }

    updateFilter(name, value) {
        const filters = { ...this.state.filters };
        filters[name] = value;

        switch (name) {
            case 'dateFrom':
                if (value) {
                    filters.dateFrom = moment(value).startOf('isoWeek').toDate();
                }
                break;
            case 'dateTo':
                if (value) {
                    filters.dateTo = moment(value).endOf('isoWeek').startOf('day').toDate();
                }
                break;
        }

        this.setState({
            filters
        }, () => {
            this.load();
        });
    }

    async exportToExcel() {
        await InstructorService.getCalendarExcel(this.state.filters);
    }

    render() {
        const { isLoading } = false;
        const loginInfo = GlobalStateService.getValue('loginInfo');

        return (<>

            <div className="page calendar-page full-width-page">

                <PageHeader hasSideBar>
                    <h1>Global Instructor Calendar</h1>

                    {loginInfo.site.enableExcelExport &&
                        <div className="buttons">

                            <button className="btn ms-3" onClick={e => this.exportToExcel()} disabled={isLoading}>
                                Export to Excel
                            </button>

                        </div>
                    }

                </PageHeader>

                <main>

                    <SideBar content={this.renderSideBarContent()} />

                    <Container fluid>

                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>

            <EditBookingModal ref={this.editBookingModalRef} />

        </>);
    }

    renderSideBarContent() {
        const {
            isLoadingFilters,
            courses,
            instructors,
            filters,
            languages,
            geos
        } = this.state;

        if (isLoadingFilters) {
            return (<Loader />);
        }

        return (<>

            <Form.Group className="mb-3">
                <Form.Label>Date from</Form.Label>
                <DatePicker
                    className="form-control"
                    selected={filters.dateFrom}
                    onChange={value => this.updateFilter('dateFrom', value)}
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Date to</Form.Label>
                <DatePicker
                    className="form-control"
                    selected={filters.dateTo}
                    onChange={value => this.updateFilter('dateTo', value)}
                    placeholder="Date (to)"
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Can deliver course</Form.Label>
                <select
                    className="form-control"
                    value={filters.courseID || ''}
                    onChange={e => this.updateFilter('courseID', e.target.value)}
                >
                    <option value="">(All courses)</option>
                    {courses.map(c =>
                        <option key={c.id} value={c.id}>{c.name} {c.tier ? `(${c.tier})` : ''}</option>
                    )}
                </select>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Language</Form.Label>
                <select
                    className="form-control"
                    value={filters.languageID || ''}
                    onChange={e => this.updateFilter('languageID', e.target.value)}
                >
                    <option value="">(All languages)</option>
                    {languages.map(l =>
                        <option key={l.id} value={l.id}>{l.name}</option>
                    )}
                </select>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Geo</Form.Label>
                {/*<select
                    className="form-control"
                    value={filters.geoID || ''}
                    onChange={e => this.updateFilter('geoID', e.target.value)}
                >
                    <option value="">(All geos)</option>
                    {geos.map(g =>
                        <option key={g.id} value={g.id}>
                            {g.name}
                        </option>
                    )}
                </select>*/}
                <FormChecks
                    isScrolling
                    allowSelectAllNone
                    id="geoIDs"
                    options={geos}
                    value={filters.geoIDs || {}}
                    onChange={options => {
                        const value = { ...filters.geoIDs };
                        for (let optionValue in options) {
                            if (options[optionValue]) {
                                value[optionValue] = true;
                            } else {
                                delete value[optionValue];
                            }
                        }
                        this.updateFilter('geoIDs', value);
                    }}
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <select
                    className="form-control"
                    value={filters.status || ''}
                    onChange={e => this.updateFilter('status', e.target.value)}
                >
                    <option value="">(All statuses)</option>
                    <option value="Available">Available</option>
                    <option value="Unavailable">Unavailable</option>
                    <option value="Active">Active</option>
                    <option value="Tentative">Tentative</option>
                    <option value="Hold">Hold</option>
                </select>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Modality</Form.Label>
                <select
                    className="form-control"
                    value={filters.modality || ''}
                    onChange={e => this.updateFilter('modality', e.target.value)}
                >
                    <option value="">ILT & vILT</option>
                    <option value="ILT">ILT</option>
                    <option value="vILT">vILT</option>
                </select>
            </Form.Group>
            
            <Form.Group className="mb-3">
                <Form.Label>Booked for course</Form.Label>
                <select
                    className="form-control"
                    value={filters.bookingCourseID || ''}
                    onChange={e => this.updateFilter('bookingCourseID', e.target.value)}
                >
                    <option value="">(Any/none)</option>
                    <option value="0">(None)</option>
                    {courses.map(c =>
                        <option key={c.id} value={c.id}>{c.name} {c.tier ? `(${c.tier})` : ''}</option>
                    )}
                </select>
            </Form.Group>
            
            <Form.Group className="mb-3">
                <Form.Label>Instructor</Form.Label>
                <select
                    className="form-control"
                    value={filters.instructorID || ''}
                    onChange={e => this.updateFilter('instructorID', e.target.value)}
                >
                    <optgroup label="Multiple instructors">
                        <option value="">(All instructors)</option>
                        <option value="priority">(Priority instructors)</option>
                        <option value="non-priority">(Non-priority instructors)</option>
                    </optgroup>
                    <optgroup label="Single instructor">
                        {instructors.map(i =>
                            <option key={i.id} value={i.id}>
                                {TextHelpers.formatInstructorName(i, true)}
                            </option>
                        )}
                    </optgroup>
                </select>
            </Form.Group>

        </>);
    }

    renderInner() {
        const {
            isLoading,
            instructorsFiltered,
            calendar,
            requestID
        } = this.state;

        if (isLoading) {
            return (<Loader fullPage />);
        }

        return (<>

            <div className="sticky-table-container scrolling">
                    {/*instructors={calendar.instructors}*/}

                <Calendar
                    calendar={calendar}
                    requestID={requestID}
                    instructors={instructorsFiltered}
                    onEditBooking={async (opt) => {
                        await this.editBookingModalRef.current.show(opt);
                        this.load();
                    }}
                />

            </div>

            <EditBookingModal ref={this.editBookingModalRef} />

        </>);
    }
}

export default withRouter(CalendarPage);